
import { Component, Vue, Prop, Watch, Emit, Ref } from 'vue-property-decorator'
import NewSwiper from '@xt/www/components/newSwiper/index.vue'
import LazyImg from '@xt/www/components/lazyImg/index.vue'
import { Observer } from 'mobx-vue'
import SwiperBtn from './swiperBtn/index.vue'

@Observer
@Component({
  components: {
    NewSwiper,
    LazyImg,
    SwiperBtn
  }
})
export default class extends Vue {
  @Ref()
  swiper: {
    handlePrev: () => void
    handleNext: () => void
  }

  data = [1, 2, 3, 4, 5, 6, 7]

  get dataSource() {
    return this.$store.$homeV2.dataSource?.teacherWorks
  }

  handleClickAbout() {
    window.open('/about-xuantong')
  }

  handleClickMore() {
    window.open('https://mp.weixin.qq.com/s/gbgYUbhdn9dHeURg0C8o-g')
  }

  prev() {
    if (!this.swiper) return
    this.swiper.handlePrev()
  }

  next() {
    if (!this.swiper) return
    this.swiper.handleNext()
  }

  created(): void {}

  mounted(): void {}

  updated(): void {}

  destroyed(): void {}
}
